/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { PersonDTO } from 'app/consulta-mark-list/interface/personDTO';
import { InfoClienteService } from 'app/consulta-mark-list/service/BehaviorSubject/infoClient.service';
import { FormatToService } from 'app/consulta-mark-list/service/Validators/format-to.service';
import { ValidatorPerson } from 'app/consulta-mark-list/service/Validators/validator-person.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';
import { SinisterService } from 'app/service/sinister.service';
import type { DynamicInputForm, OptionCombobox } from 'app/core/interfaces';

import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { GenericTableAvlaService } from 'generic_table_avla_front_components';
import moment from 'moment';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  MessageService,
  UiDatepickerDirective,
} from 'shared-angular-components-avla';

import { iif } from 'rxjs';

import type { CountryDto, Select2OptionData } from 'app/core/models';
import { CountryISO, IdentificationTypes } from 'app/core/enums';
import { getCountryNameByIso } from 'app/core/utils';

import {
  CountryDniRelation,
  CountryWithDefinedDNI,
} from './constants/country-dni.constant';
import { CountriesService } from '../../../../service/countries.service';
import { StatusRegisterDTO } from '../../../interface/newStatusRegister';

@Component({
  selector: 'app-ml-form-dinamic',
  templateUrl: './ml-form-dinamic.component.html',
  styleUrls: ['./ml-form-dinamic.component.css'],
  providers: [DatePipe, UiDatepickerDirective],
})
export class MlFormDinamicComponent
  extends AvlaGenericComponent
  implements OnInit
{
  @ViewChild('statusPersonView', { static: false }) statusPersonView: any;
  @Output() registroExitoso: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  // Form
  reactiveForm: FormGroup;
  dinamicFormInputsData: DynamicInputForm[];
  // Country
  public countries: CountryDto[] = [];
  public countriesDto: Array<Select2OptionData> =
    new Array<Select2OptionData>();
  countryCodeSel = CountryISO.Otro as string; // TODO Setear al solo en el submit
  identificationTypesByCountry: any[] = [];
  // PersonType
  personTypeList: any[] = [];
  loadingImgPersonType: boolean;
  loadingImg = false;
  // IdentificationType
  identificationTypeList: OptionCombobox[] = [];

  constructor(
    protected validatorPersonService: ValidatorPerson,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected renderer: Renderer2,
    protected marklistService: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService,
    protected infoClientSubject: InfoClienteService,
    protected formBuilder: FormBuilder,
    protected sinisterService: SinisterService,
    protected formatToService: FormatToService,
    public countriesService: CountriesService,
    protected i18n: I18nService
  ) {
    super(restClientService, messageService, router, authService, i18n);
  }

  ngOnInit() {
    this.createForm();
    this.getDynamicFormInputs();
    this.loadCountries();
  }

  //? ==================== Create Form ====================

  /**
   * Se crea el formulario
   */
  createForm() {
    this.reactiveForm = this.formBuilder.group(
      {
        namePerson: ['', Validators.required],
        identificationType: ['', Validators.required],
        dniPerson: ['', Validators.required],
        personType: ['', Validators.required],
        countryIso: ['', Validators.required],
      },
      {
        validator: this.customValidation.bind(this),
      }
    );
  }

  /**
   * Se crean las validaciones del formulario
   * @param form
   */
  customValidation(form: FormGroup) {
    const identificationType = form.controls.identificationType.value;
    const dniPerson = form.controls.dniPerson.value;
    this.validateDni(dniPerson, identificationType, form);
  }

  get customValidationErrorsForDni() {
    const control = this.reactiveForm.get('dniPerson');
    if (!control) return false;

    const identificationType =
      this.reactiveForm.get('identificationType').value;

    const cleanValue = (control.value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');

    const isCnpjCompleteAndInvalid =
      identificationType === IdentificationTypes.CB_IDENTIFICACION_CNPJ &&
      cleanValue.length >= 14 &&
      control.hasError('customInvalid');

    return (
      control.hasError('customInvalid') &&
      (control.touched || isCnpjCompleteAndInvalid)
    );
  }

  /**
   * Se obtienen los formInputs a utilizar con su label y orden
   */
  getDynamicFormInputs(): void {
    const date = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
    this.sinisterService
      .getDynamicFormInputsAtDate('DF_REGISTRO_USUARIO', date)
      .subscribe({
        next: res => {
          this.dinamicFormInputsData = res;
          this.getIdentificationTypes();
        },
        error: err => console.error('error', err),
      });
  }

  /**
   * Se obtiene la label dado el nombre del input
   * @param inputName
   * @returns
   */
  getDynamicFormLabelByInputName(inputName: string): string {
    return this.dinamicFormInputsData.find(
      input => input.inputName === inputName
    ).label;
  }

  //? ==================== Country ====================

  /**
   * Filtra los tipos de documentos al seleccionar país
   * @param $event
   */
  onChangeCountry($event: any): void {
    const isoCode: string = $event.value;
    // Se actualiza el listado de identificationType
    this.updateIdentificationTypeByCountry(isoCode);
    this.countryCodeSel = isoCode;
  }

  /**
   * Se llama al endpoint que obtiene los paises
   */
  loadCountries(): void {
    this.countriesService.findAllCountries().subscribe(
      data => {
        if (this.errorInResponse(data)) return;
        this.getCountries(data);
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  /**
   * Se asignan los paises
   * @param countries
   */
  getCountries(countries: CountryDto[]): void {
    this.countriesDto = countries.map(x => ({
      value: x.isoCode,
      label: x.name,
    }));

    this.countriesDto.unshift({
      value: '',
      label: this.i18n.getTranslation(
        'RSCFC_DEBTORS_REPORTS_COMPONENT_COLUMN_DEBTORS_TABLE_SELECT'
      ),
    });
  }

  //? ==================== Identification Type ====================

  onChangeIdentificationType(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Si ya fue tocado el input de dni, se valida nuevamente
    if (this.reactiveForm.get('dniPerson').touched) {
      this.validateDni(
        this.reactiveForm.get('dniPerson').value,
        currentValue,
        this.reactiveForm
      );
    }

    // Se remueve el valor del tipo de persona
    this.reactiveForm.get('personType').setValue(null);
    // Se obtiene el tipo de persona
    this.getPersonType();
  }

  updateIdentificationTypeByCountry(isoCode: string): void {
    const currentIso: CountryISO = CountryWithDefinedDNI.includes(
      isoCode as CountryISO
    )
      ? (isoCode as CountryISO)
      : CountryISO.Otro;

    const validOptionsByCountry: string[] = CountryDniRelation.filter(
      cd => cd.isoCode === currentIso
    ).map(identification => identification.option);

    this.identificationTypesByCountry = this.identificationTypeList.filter(it =>
      validOptionsByCountry.includes(it.cdOption)
    );

    // Se remueve el valor de tipo de identificación para que se valide el DNI
    this.reactiveForm.get('identificationType').setValue(null);
  }

  getIdentificationTypes(): void {
    const identificationType = this.dinamicFormInputsData.find(
      field => field.inputName === 'identificationType'
    );
    this.identificationTypeList = identificationType.possibleValues;
  }

  //? ==================== Documento de identidad (DNI) ====================

  /**
   * Validar que lo que el usuario ingrese en el input de DNI sean números
   * o números + la letra K (validación para RUT de Chile)
   *
   * @param {*} event
   * @memberof MlFormDinamicComponent
   */
  onInputDni(event: Event): void {
    // Valida que la limpieza del input solo se ejecutara para Chile
    if (this.countryCodeSel !== (CountryISO.Chile as string)) return;

    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Filtra los caracteres que no sean númericos o la letra "K"
    const fixedValue = currentValue.replace(/[^0-9Kk]/g, '');

    // Actualiza el valor en el input
    inputElement.value = fixedValue;

    // Actualiza el valor en el formulario
    this.reactiveForm
      .get('dniPerson')
      .setValue(fixedValue, { emitEvent: false });
  }

  /**
   * @param dniPerson
   * Valida el DNI por tipo de identificación y setea error si no es valido
   * @param identificationType
   * @param form
   * @returns
   */
  validateDni(
    dniPerson: string,
    identificationType: string,
    form: FormGroup
  ): boolean {
    const isValid = this.validatorPersonService.validate(
      dniPerson,
      identificationType
    );

    const errors = isValid ? null : { customInvalid: true };
    form.controls.dniPerson.setErrors(errors);
    return isValid;
  }

  //? ==================== Tipo de persona ====================

  getPersonType() {
    const identificationType =
      this.reactiveForm.get('identificationType').value;
    const registerType =
      this.formatToService.formatToIdentificationTypeFromBack(
        identificationType
      );

    if (registerType == null) {
      const personType = this.dinamicFormInputsData.find(
        field => field.inputName === 'personType'
      );
      this.personTypeList = personType?.possibleValues ?? [];
    } else {
      this.loadingImgPersonType = true;
      this.sinisterService.getOptionsCombobox(registerType).subscribe({
        next: res => (this.personTypeList = res),
        error: err => console.error(err),
        complete: () => (this.loadingImgPersonType = false),
      });
    }
  }

  // este es el metodo que agrega la persona, aca tengo que ver si es solicitud o no, y agregar directamente o a la pantalla de solicitudes, este es nueva persona, se parece al otro, y tambien parece solo de bloqueos
  submitForm() {
    const statusData = this.statusPersonView.getStatusData();

    const countryIso =
      this.reactiveForm.get('countryIso').value! || this.countryCodeSel;

    if (!statusData || !this.reactiveForm.valid) return;
    const personDTO = this.reactiveForm.value;
    const identificationType =
      this.reactiveForm.get('identificationType').value!;

    const dniPerson = this.reactiveForm.get('dniPerson').value;
    const isValidDni = this.validateDni(
      dniPerson,
      identificationType,
      this.reactiveForm
    );

    if (!isValidDni) return;

    personDTO.identificationType =
      this.formatToService.formatToIdentificationType(identificationType);

    personDTO.countryIso = countryIso;

    // TODO: Person Type

    this.savePerson(personDTO, statusData);
  }

  savePerson(personDTO: PersonDTO, statusData: StatusRegisterDTO): void {
    this.loadingImg = true;
    iif(
      () => this.isAllowedToBlockDirectly(),
      this.marklistService.setPerson(
        personDTO,
        statusData,
        this.countryCodeSel
      ),
      this.marklistService.setRequest(
        personDTO,
        statusData,
        this.countryCodeSel
      )
    ).subscribe({
      next: () => {
        this.messageService.announcedMessage(
          new InfoMessageDTO(
            'success',
            'Se ha ingresado registro',
            AvlaGenericComponent.TIME_NOTIFICATION
          )
        );
        this.registroExitoso.emit(true);
      },
      error: err => {
        if (this.errorInResponse(err)) {
          return;
        }
        this.messageService.announcedMessage(
          new InfoMessageDTO(
            'danger',
            'No se a podido ingresar el registro. Vuelva a intentarlo',
            AvlaGenericComponent.TIME_NOTIFICATION
          )
        );
        this.loadingImg = false;
        //this.registroExitoso.emit(true);
        this.routeAccordingError(err);
      },
    });
  }

  //? ==================== Otras funciones ====================

  // TODO: Función no se esta llamando. Verificar si se puede eliminar
  saveRequest(personDTO: PersonDTO, statusData: StatusRegisterDTO): void {
    this.loadingImg = true;
    this.marklistService
      .setRequest(personDTO, statusData, this.countryCodeSel)
      .subscribe({
        next: () => {
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'success',
              'Se ha ingresado la solicitud',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.registroExitoso.emit(true);
        },
        error: err => {
          if (this.errorInResponse(err)) {
            return;
          }
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'danger',
              'No se a podido ingresar la solicitud. Vuelva a intentarlo',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.loadingImg = false;
          //this.registroExitoso.emit(true);
          this.routeAccordingError(err);
        },
      });
  }

  private isAllowedToBlockDirectly(): boolean {
    return this.authService.isAllowedHtmlElement(19506, 'BTN_DIRECT_BLOCK');
  }
}
